import { oz } from '@weft/utils';
import { ProductUsageReportSchema } from './product-usage-report-schema';

export const ProductsUsageReportSchema = oz.array(ProductUsageReportSchema);

export type ProductsUsageReport = oz.TypeOf<typeof ProductsUsageReportSchema>;